/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

/*-- start Lobstter custom code */

(function() {
  // Add custom code below this line
  function closeUpsellPopup() {
    document.getElementById("UpsellMoreInfoContainer").classList.remove('is_open');
  }

  document.querySelector("#UpsellMoreInfoContainer .overlay").addEventListener("click", closeUpsellPopup);
  document.querySelector("#UpsellMoreInfoContainer .popup_close").addEventListener("click", closeUpsellPopup);

  
  document.querySelector('.select_contry_button').addEventListener('click', function() {
    document.querySelector('.header_country_selector').classList.toggle('active');
  });

  document.addEventListener("click", function(e) {
    if (!document.querySelector('.header_country_selector').contains(e.target)) {
      document.querySelector('.header_country_selector').classList.remove("active");
    }
  });
/*-- end Lobstter custom code */


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
